/**
 * Safe browser utility functions to handle browser-specific properties
 * that might not be available in all environments or browsers
 */

/**
 * Safely get window.location properties
 */
export function getWindowLocation() {
	if (typeof window === 'undefined' || !window.location) {
		return null;
	}

	return {
		href: window.location.href || '',
		pathname: window.location.pathname || '',
		search: window.location.search || '',
		hash: window.location.hash || '',
		hostname: window.location.hostname || '',
		host: window.location.host || '',
		protocol: window.location.protocol || '',
		origin: window.location.origin || '',
	};
}

/**
 * Check if we're in a browser environment
 */
export function isBrowser() {
	return typeof window !== 'undefined' && typeof document !== 'undefined' && window.location !== undefined;
}

/**
 * Safely reload the page
 */
export function safeReload() {
	if (isBrowser() && window.location?.reload) {
		window.location.reload();
	}
}

/**
 * Safely navigate to a URL
 */
export function safeNavigate(url: string) {
	if (isBrowser() && window.location) {
		window.location.href = url;
	}
}

/**
 * Get URL search params safely
 */
export function getSearchParams(search?: string) {
	try {
		const location = getWindowLocation();
		const searchString = search || location?.search || '';
		return new URLSearchParams(searchString);
	} catch {
		return new URLSearchParams();
	}
}
